import { render, staticRenderFns } from "./ProbelCancelAppointment.vue?vue&type=template&id=bf5a41a8"
import script from "./ProbelCancelAppointment.vue?vue&type=script&lang=js"
export * from "./ProbelCancelAppointment.vue?vue&type=script&lang=js"
import style0 from "./ProbelCancelAppointment.vue?vue&type=style&index=0&id=bf5a41a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports